import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { BellRing, Loader2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { TemplateEditor, TemplateSection } from './ReminderSettingsCard';

const KVKK_VARS = ['yetkili', 'firma', 'surum', 'indirme_linki', 'yukleme_linki', 'gecen_gun', 'hatirlatma_no'];
const PUBLISH_VARS = ['yetkili', 'firma', 'surum', 'indirme_linki', 'yukleme_linki'];

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const KvkkReminderSettingsCard = () => {
  const [days, setDays] = useState('');
  const [templates, setTemplates] = useState({});
  const [defaults, setDefaults] = useState({});
  const [saving, setSaving] = useState(false);

  const apply = (data) => {
    setDays(String(data.kvkk_reminder_days));
    setTemplates(data.templates || {});
    setDefaults(data.default_templates || {});
  };

  useEffect(() => {
    axios.get(`${API}/settings/kvkk-reminder`).then(res => apply(res.data)).catch(() => setDays('3'));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const res = await axios.put(`${API}/settings/kvkk-reminder`, { kvkk_reminder_days: Number(days), templates });
      apply(res.data);
      toast.success('KVKK hatırlatma ayarları kaydedildi');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Kaydedilemedi');
    } finally { setSaving(false); }
  };

  return (
    <Card className="border-slate-200" data-testid="kvkk-reminder-settings-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><BellRing className="h-5 w-5" />KVKK Taahhütnamesi Hatırlatması</CardTitle>
        <CardDescription>Yeni taahhütname yayınlandıktan sonra yüklemeyen firmalara, yükleyene kadar bu aralıkla otomatik e-posta gönderilir (her sabah 07:00 kontrol edilir).</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-end gap-3 flex-wrap">
        <div className="space-y-1">
          <label htmlFor="kvkk-reminder-days" className="text-sm font-medium text-slate-700">Kaç günde bir?</label>
          <div className="flex items-center gap-2">
            <Input id="kvkk-reminder-days" type="number" min={1} max={60} value={days} onChange={(e) => setDays(e.target.value)} className="w-24" data-testid="kvkk-reminder-days-input" />
            <span className="text-sm text-slate-500">günde bir</span>
          </div>
        </div>
        <Button onClick={save} disabled={saving || !days} className="bg-slate-900 hover:bg-slate-800" data-testid="kvkk-reminder-save">
          {saving && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Kaydet
        </Button>
        </div>
        <TemplateSection testId="kvkk">
          <TemplateEditor label="Yeni taahhütname yayınlandığında gönderilen e-posta" prefix="kvkk_publish" vars={PUBLISH_VARS} templates={templates} defaults={defaults} onChange={(p) => setTemplates(t => ({ ...t, ...p }))} />
          <TemplateEditor label="Yüklemeyen firmalara gönderilen hatırlatma e-postası" prefix="kvkk_reminder" vars={KVKK_VARS} templates={templates} defaults={defaults} onChange={(p) => setTemplates(t => ({ ...t, ...p }))} />
          <p className="text-[11px] text-slate-500">{'{indirme_linki}'} ve {'{yukleme_linki}'} e-postada tıklanabilir bağlantı olarak görünür. Değişiklikler için yukarıdaki "Kaydet"e basın.</p>
        </TemplateSection>
      </CardContent>
    </Card>
  );
};
